import { getCurrentUser } from '@/utils/auth.util'
import { refreshCurrentUser } from '@/utils/refreshCurrentUser.util'
import { isAxiosError } from 'axios'

const ACCESS_LOST_STATUSES = new Set([401, 403, 404])

export async function hasLostInitiativeAccess(
  error: unknown,
  initiativeId: string | number
): Promise<boolean> {
  if (
    !isAxiosError(error) ||
    !ACCESS_LOST_STATUSES.has(error.response?.status ?? 0)
  ) {
    return false
  }

  await refreshCurrentUser()
  const user = getCurrentUser()
  return !user?.hasInitiativeDashboardAccess(Number(initiativeId))
}
